// extracted by mini-css-extract-plugin
module.exports = {"loader":"Xa","smallLoader":"Ya","loading-keyframes":"Za","pageLoader":"_a","centered":"ab","whitespacePlaceholder":"bb","buttonSpinner":"cb","fade-in":"db","rotate":"eb"};